import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

let isDatadogInitialized = false;

export const getProductType = (
  loungeCode?: string
): 'FAST_TRACK' | 'LOUNGE' | 'Unknown' => {
  if (!loungeCode || loungeCode === 'Unknown') {
    return 'Unknown';
  }

  return loungeCode.endsWith('FT') ? 'FAST_TRACK' : 'LOUNGE';
};

export function initDatadogMonitoring() {
  if (isDatadogInitialized) return true;

  const version = process.env.NEXT_PUBLIC_APP_VERSION;

  const datadogenv: string | undefined = process.env.NEXT_PUBLIC_DATADOG_ENV;

  if (!datadogenv) return false;

  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
    env: datadogenv,
    forwardErrorsToLogs: true,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? '',
    sessionSampleRate: 100,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE ?? '',
  });

  datadogRum.init({
    actionNameAttribute: 'data-custom-name',
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID ?? '',
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['feature_flags'],
    env: datadogenv,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? '',
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE ?? '',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: version ?? 'n/a',
  });

  datadogRum.startSessionReplayRecording();
  isDatadogInitialized = true;
  return true;
}
